import types from 'constants/PaymentConstants';
import axios from 'axios';
import qs from 'qs';
import {getURL} from '../routes';

//Payment
export function fetchPaymentListAPI(cid) {
  return axios.get(getURL('/api/construction/') + cid + '/cost')
}

export function addPaymentAPI(cid, type, amount, notes) {
  return axios.post(getURL('/api/construction/') + cid + '/cost',
                qs.stringify({
                  'type': type,
                  'amount': amount,
                  'notes': notes
                }))
}

export function deletePaymentAPI(cid, id) {
  return axios.delete(getURL('/api/construction/') + cid + '/cost/' + id)
}

export function updatePaymentAPI(cid, id, amount, notes) {
  return axios.put(getURL('/api/construction/') + cid + '/cost/' + id,
                qs.stringify({
                  'amount': amount,
                  'notes': notes
                }))
}

export function updateTotoalPriceAPI(cid, amount) {
  return axios.put(getURL('/api/construction/') + cid + '/cost',
                qs.stringify({
                  'amount': amount,
                }))
}

export function fetchPaymentList(cid) {
  return dispatch => {
    fetchPaymentListAPI(cid)
      .then((response) => {
        let {labour, payment, totalPrice=0} = response.data;
        dispatch(refreshPaymentList(labour, payment, totalPrice));
      })
      .catch((error) => {

      })
  }
}

export function tryAddPayment(cid, type, amount, notes, callback) {
  return dispatch => {
    addPaymentAPI(cid, type, amount, notes)
      .then((response) => {
        let {id} = response.data;
        if (id > 0) {
          dispatch(addPayment(id, type, amount, notes));
        }
        callback && callback();
      })
      .catch((error) => {

      })
  }
}

export function tryDeletePayment(cid, id, cate) {
  return dispatch => {
    deletePaymentAPI(cid, id)
      .then((response) => {
        response.data.success && dispatch(deletePayment(cate, id))
      })
      .catch((error) => {

      })
  }
}

export function tryUpdatePayment(cid, id, cate, amount, notes) {
  return dispatch => {
    updatePaymentAPI(cid, id, amount, notes)
      .then((response) => {
        response.data.success && dispatch(updatePayment(cate, id, amount, notes))
      })
      .catch((error) => {

      })
  }
}

export function tryUpdateTotalPrice(cid, amount) {
  return dispatch => {
    return updateTotoalPriceAPI(cid, amount)
      .then((response) => {
        const success = response.data;
        if (!success) {
          alert("操作失敗");
        }
        dispatch(updateTotalPrice(amount));
      })
      .catch(e => {});
  }
}

export function refreshPaymentList(labour, paymentList, totalPrice) {
  return {
    type: types.REFRESH_PAYMENT_LIST,
    labour, paymentList, totalPrice
  }
}

export function addPayment(id, paymentType, amount, notes) {
  return {
    type: types.ADD_PAYMENT,
    id, paymentType, amount, notes
  }
}

export function deletePayment(cate, id) {
  return {
    type: types.DELETE_PAYMENT,
    cate, id
  }
}

export function updatePayment(cate, id, amount, notes) {
  return {
    type: types.UPDATE_PAYMENT,
    cate, id, amount, notes
  }
}

export function updateTotalPrice(amount) {
  return {
    type: types.UPDATE_TOTAL_PRICE,
    totalPrice: amount
  }
}

//Payment Type
export function fetchPaymentTypeListAPI() {
  return axios.get(getURL('/api/payment/type'))
}

export function addPaymentTypeAPI(name) {
  return axios.post(getURL('/api/payment/type'),
                qs.stringify({'name': name}))
}

export function updatePaymentTypeNameAPI(id, name) {
  return axios.put(getURL('/api/payment/type/') + id,
                qs.stringify({'name': name}))
}

export function deletePaymentTypeAPI(id) {
  return axios.delete(getURL('/api/payment/type/') + id)
}

export function fetchPaymentTypeList() {
  return dispatch => {
    fetchPaymentTypeListAPI()
      .then((response) => {
        let {typeList} = response.data;
        dispatch(refreshPaymentTypeList(typeList));
      })
      .catch((error) => {

      })
  }
}

export function tryUpdatePaymentTypeName(id, name) {
  return dispatch => {
    updatePaymentTypeNameAPI(id, name)
      .then((response) => {
        dispatch(updatePaymentTypeName(id, name))
      })
      .catch((error) => {

      })
  }
}

export function tryAddPaymentType(name) {
  return dispatch => {
    addPaymentTypeAPI(name)
      .then((response) => {
        let {id} = response.data;
        dispatch(addPaymentType(id, name))
      })
      .catch(() => {
        alert("新增帳單類別失敗")
      })
  }
}

export function tryDeletePaymentType(id) {
  return dispatch => {
    deletePaymentTypeAPI(id)
      .then((response) => {
        dispatch(deletePaymentType(id))
      })
      .catch((error) => {
        alert("删除失敗!")
      })
  }
}

export function refreshPaymentTypeList(typeList) {
  return {
    type: types.REFRESH_PAYMENT_TYPE_LIST,
    typeList
  }
}

export function updatePaymentTypeName(id, name) {
  return {
    type: types.UPDATE_PAYMENT_TYPE_NAME,
    id, name
  }
}

export function deletePaymentType(id) {
  return {
    type: types.DELETE_PAYMENT_TYPE,
    id
  }
}

export function addPaymentType(id, name) {
  return {
    type: types.ADD_PAYMENT_TYPE,
    id, name
  }
}



// WEBPACK FOOTER //
// ./src/actions/PaymentActions.js